import type { ScheduleDay } from '../../config/types';

export interface SelectOption {
  value: string;
  label: string;
}

/** Days from `schedule` that are today or later — ported from otm_so_2026_06's scheduleData.js,
 *  generalized to read the day list from campaign config instead of a hardcoded object. */
export function getAvailableDays(schedule: ScheduleDay[]): SelectOption[] {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return schedule
    .filter((day) => new Date(`${day.date}T00:00:00`) >= today)
    .map((day) => ({ value: day.date, label: day.label }));
}

/** Times for the selected day, filtering out already-passed slots when the selected day is today. */
export function getEventsForDay(schedule: ScheduleDay[], selectedDate: string | undefined): SelectOption[] {
  const day = schedule.find((d) => d.date === selectedDate);
  if (!day) return [];

  const now = new Date();
  const selectedDateObj = new Date(`${day.date}T00:00:00`);
  const isToday = selectedDateObj.toDateString() === now.toDateString();

  return day.times
    .filter((time) => {
      if (!isToday) return true;
      const [hours, minutes] = time.split(':').map(Number);
      const eventTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);
      return eventTime > now;
    })
    .map((time) => ({ value: time, label: time }));
}
